import * as React from "react"
import { Heading, HeadingProps } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"

interface ElementTitleProps extends HeadingProps {
  text: string
}

const _ElementTitle: React.FC<ElementTitleProps> = ({
  text,
  ...props
}): React.ReactElement => {
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Heading
      as="h5"
      display="flex"
      alignItems="center"
      marginBottom="0.4rem"
      fontSize="xl"
      lineHeight="1.5"
      fontWeight="500"
      color={roomStyles?.servicePanelElementPrimaryText ?? "black"}
      {...props}
    >
      {text}
    </Heading>
  )
}

export const ElementTitle = React.memo(_ElementTitle)
